// =======================================================
// Fehlerprotokoll für Meldungen
//
// Merkt sich die letzten Fehler und Warnungen aus dem Browser, damit eine
// Meldung über den Knopf in der Kopfzeile zeigen kann, was kurz vorher schief
// lief. Bleibt nur im Speicher des Tabs, wird nirgends hingeschickt — außer
// jemand reicht eine Meldung ein.
// =======================================================

export interface ProtokollEintrag {
  zeit: Date;
  art: 'Fehler' | 'Warnung' | 'Absturz';
  text: string;
}

const MAX_EINTRAEGE = 20;
const MAX_ZEICHEN = 600;
const eintraege: ProtokollEintrag[] = [];
let aktiv = false;

function alsText(wert: unknown): string {
  if (wert instanceof Error) return `${wert.name}: ${wert.message}`;
  if (typeof wert === 'string') return wert;
  try {
    return JSON.stringify(wert);
  } catch {
    return String(wert);
  }
}

function merken(art: ProtokollEintrag['art'], teile: unknown[]) {
  const text = teile.map(alsText).join(' ').replace(/\s+/g, ' ').trim().slice(0, MAX_ZEICHEN);
  if (!text) return;
  eintraege.push({ zeit: new Date(), art, text });
  if (eintraege.length > MAX_EINTRAEGE) eintraege.shift();
}

/** Einmal beim Start aufrufen; weitere Aufrufe tun nichts. */
export function fehlerprotokollStarten() {
  if (aktiv || typeof window === 'undefined') return;
  aktiv = true;

  const urError = console.error.bind(console);
  const urWarn = console.warn.bind(console);
  console.error = (...args: unknown[]) => {
    merken('Fehler', args);
    urError(...args);
  };
  console.warn = (...args: unknown[]) => {
    merken('Warnung', args);
    urWarn(...args);
  };

  window.addEventListener('error', (e) => {
    const ort = e.filename ? ` (${e.filename.split('/').pop()}:${e.lineno})` : '';
    merken('Absturz', [`${e.message}${ort}`]);
  });
  window.addEventListener('unhandledrejection', (e) => {
    merken('Absturz', ['Unbehandelt:', e.reason]);
  });
}

export function fehlerprotokoll(): ProtokollEintrag[] {
  return [...eintraege];
}
